import { Component, Input, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { BrandingService } from '../../../core/services/branding.service';

@Component({
    selector: 'app-faq-question',
    templateUrl: './faq-question.component.html',
    standalone: false
})
export class FaqQuestionComponent {

  @ViewChild('accordion', { static: true }) accordion: MatAccordion;
  @Input() question;
  @Input() answer;
  @Input() search;
  public readonly faqColor$ = this.brandingService.faqColor$

  constructor(private brandingService: BrandingService) { }

  openAll() {
    this.accordion.openAll();
  }

  closeAll() {
    this.accordion.closeAll();
  }
}
